// extracted by mini-css-extract-plugin
export default {"content":"PrivacyPoliciesPage_content__uWtZJ","otherLegalReqItem":"PrivacyPoliciesPage_otherLegalReqItem__UW+Di","oneTab":"PrivacyPoliciesPage_oneTab__xW+m9"};